import { z } from "zod"

export const REVIEW_CONTENT_MAX_LENGTH = 300

export const reviewSchema = z.object({
  sellerId: z.string(),
  rating: z.number().min(1, "Please rate this seller").max(5),
  opinion: z
    .string()
    .max(
      REVIEW_CONTENT_MAX_LENGTH,
      "Opinion must be less than 300 characters"
    )
    .optional(),
})

export type ReviewFormData = z.infer<typeof reviewSchema>


export const reviewOrderSchema = z.object({
  seller: z.object({
    id: z.string(),
    rating: z.number().min(1, "Please rate this seller").max(5),
    customer_note: z
      .string()
      .min(0)
      .max(
        REVIEW_CONTENT_MAX_LENGTH,
        "Review content must be less than 300 characters"
      ),
  }),
  products: z.array(
    z.object({
      id: z.string(),
      rating: z.number().min(1, "Please rate this product").max(5),
      customer_note: z
        .string()
        .min(0)
        .max(
          REVIEW_CONTENT_MAX_LENGTH,
          "Review content must be less than 300 characters"
        ),
    })
  )
})

export type ReviewOrderFormData = z.infer<typeof reviewOrderSchema>
